import { render } from "./Join.vue?vue&type=template&id=2f055bd8&scoped=true"
import script from "./Join.vue?vue&type=script&lang=js"
export * from "./Join.vue?vue&type=script&lang=js"

import "./Join.vue?vue&type=style&index=0&id=2f055bd8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2f055bd8"

export default script